var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating"},[_c('div',_vm._l((5),function(index){return _c('v-icon',{key:index,attrs:{"color":index <= _vm.rating ? 'yellow' : 'grey lighten-1'}},[_vm._v("mdi-star")])}),1),_c('span',{staticClass:"reviews"},[_vm._v("("+_vm._s(_vm.reviewsCount)+" avaliações)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }